import { render, staticRenderFns } from "./mobIntroduce.vue?vue&type=template&id=0c5383fc&scoped=true&"
import script from "./mobIntroduce.vue?vue&type=script&lang=js&"
export * from "./mobIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./mobIntroduce.vue?vue&type=style&index=0&id=0c5383fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5383fc",
  null
  
)

export default component.exports